import { CommonModule } from "@angular/common";
import {
  provideHttpClient,
  withInterceptorsFromDi,
} from "@angular/common/http";
import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { NgbDatepickerModule } from "@ng-bootstrap/ng-bootstrap";
import { NgSelectModule } from "@ng-select/ng-select";
import { TranslateModule } from "@ngx-translate/core";
import { AlertsService } from "app/shared/alert/alert-service";
import { DataTableModule } from "app/shared/angular2-datatable/DataTableModule";
import { ConfirmService } from "app/shared/confirm/confirm.service";
import { SharedModule } from "app/shared/shared.module";
import { CampaignComponent } from "./campaign/campaign.component";
import { LiabrariesComponent } from "./liabraries/liabraries.component";
import { OperationsComponent } from "./operations/operations.component";
import { PmmlComponent } from "./pmml/pmml.component";
import { ProcessComponent } from "./process-list/Process/process.component";
import { ProcessListComponent } from "./process-list/process-list.component";
import { ProcessManagementRoutingModule } from "./process-management-routing.module";
import { PythonComponent } from "./python/python.component";
import { TablesComponent } from "./tables/tables.component";
import { WhatifComponent } from "./whatif/whatif.component";

@NgModule({
  declarations: [
    ProcessComponent,
    OperationsComponent,
    LiabrariesComponent,
    TablesComponent,
    CampaignComponent,
    PmmlComponent,
    PythonComponent,
    WhatifComponent,
    ProcessListComponent,
  ],
  exports: [],
  imports: [
    CommonModule,
    ProcessManagementRoutingModule,
    TranslateModule,
    SharedModule,
    FormsModule,
    ReactiveFormsModule,
    NgSelectModule,
    NgbDatepickerModule,
    DataTableModule,
  ],
  providers: [
    AlertsService,
    ConfirmService,
    provideHttpClient(withInterceptorsFromDi()),
  ],
})
export class ProcessManagementModule {}
